import i18next from 'i18next'
import { FormErrors } from 'redux-form'
import { isEmpty } from 'lodash'

// types
import { IForm } from '../../../types/interfaces'

export default (values: IForm) => {
	const errors: FormErrors<IForm> = {}

	if (!values?.name) {
		errors.name = i18next.t('loc:Toto pole je povinné') as string
	}

	if (!values?.type || isEmpty(values?.type)) {
		errors.type = i18next.t('loc:Toto pole je povinné') as string
	}

	return errors
}
